export const QUESTION_POOL_MODE = 'QUESTION_POOL_MODE';
export const CHATROOM_MODE = 'CHATROOM_MODE';



// WEBPACK FOOTER //
// ./src/constants/modeOfTutorHome.js